<template>
	<div style="padding: 10px;">
		<!-- <div style="display: none;">
			<div style="width: 180px;text-align: right;float: right;margin-right: 10px;">
				<el-button type="primary" @click="showimportfromcj = true" icon="el-icon-upload">导入外机</el-button>
			</div>
			<div style="clear: both;"></div>
		</div> -->
		<div >
			<div style="width: 42%;float: left;margin-top: 10px;margin-right: 10px;">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-cascader style="width: 100%;" v-model="searchInfo.orgs" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-col>
					<el-col :span="12">
						<el-input clearable placeholder="设备名称查询" v-model="searchInfo.name">
							<template slot="prepend">设备名称</template>
						</el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20" style="margin-top: 20px;">
					<el-col :span="24">
						<div style="min-width: 400px;">
							<el-button type="primary" @click="searchDev" icon="el-icon-search">搜索</el-button>
							<!-- <el-button type="primary" icon="el-icon-plus" @click="addStall">添加设备</el-button> -->
							<el-button type="danger" icon="el-icon-delete" @click="deleteSelectedRealDev">删除设备</el-button>
							<el-button type="primary" @click="showimportfromcj = true" icon="el-icon-upload">导入外机</el-button>
						</div>
					</el-col>
				</el-row>
				<div >
					<el-table highlight-current-row :data="orgDevList"  style="width: 100%"  max-height="640" 
						@row-click="rowSelected" @selection-change="handleSelectionChange">
						<el-table-column type="selection" align="center" width="55"> </el-table-column>
						<el-table-column fixed="left" prop="name" label="名称" width="150" align="center"></el-table-column>
					    <el-table-column prop="code" label="编码"  width="100" align="center"></el-table-column>
						<el-table-column prop="type" label="类型" align="center"></el-table-column>
						<el-table-column prop="model" label="品牌型号" align="center"></el-table-column>
						<el-table-column prop="idx" label="排序"  align="center"></el-table-column>
						<el-table-column fixed="right" prop="op" label="操作" width="120" align="center">
							<template slot-scope="scope">
								<a @click.stop="goDevDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
									<i class="el-icon-Stall">详情</i>
								</a>
								<a @click.stop="deleteDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
									<i class="el-icon-Stall">删除</i>
								</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="text-align: center;">
					<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
						:page-size="param.pagenum" :total="devTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
				</div>
			</div>
			<div style="width: 54%;float: left;margin-top: 10px;margin-left: 10px;">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-input clearable placeholder="按点位名称查询" v-model="searchPointInfo.name">
							<template slot="prepend">点位名称</template>
						</el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20"  style="margin-top: 20px;">
					<el-col :span="24"> 
						<div style="min-width: 200px;">
							<el-button type="primary" @click="searchDevPoint" icon="el-icon-search">搜索</el-button>
							<el-button type="primary" icon="el-icon-plus" @click="addPointStall">添加点位</el-button>
						</div>
					</el-col>
				</el-row>
				<div >
					<el-table :data="orgDevPointList"  style="width: 100%"  max-height="640">
					    <el-table-column fixed="left" prop="point_name" label="点位名称" width="150" align="center"></el-table-column>
						<el-table-column prop="point_code" label="编码" width="150" align="center"></el-table-column>
						<el-table-column prop="point_type" label="类型" width="90" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.point_type =='digital' ? '状态量' : '模拟量'}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="unit" label="单位" width="70" align="center"></el-table-column>
						<el-table-column prop="value_expression" label="取值公式" width="240" align="center"></el-table-column>
						<el-table-column prop="controll_expression" label="控制公式" width="240" align="center"></el-table-column>
						<el-table-column prop="value_include" label="取值引用" width="240" align="center"></el-table-column>
						<el-table-column prop="controll_include" label="控制引用" width="240" align="center"></el-table-column>
						<el-table-column prop="value_enum" label="枚举" width="240" align="center"></el-table-column>
						<el-table-column fixed="right" prop="op" label="操作" width="120" align="center">
							<template slot-scope="scope">
								<a @click="goDevPointDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
									<i class="el-icon-Stall">详情</i>
								</a>
								<a @click="deletePointDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
									<i class="el-icon-Stall">删除</i>
								</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="text-align: center;">
					<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="pointparam.page"
						:page-size="pointparam.pagenum" :total="devPointTotal" @size-change="handlePointSizeChange" @current-change="handlePointCurrentChange"> </el-pagination>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
		
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<div>
				<el-form :inline="false" :model="adddevinfo" :rules="rules" ref="devrule" label-width="120px" class="">
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="所属校区" prop="orgid">
								<el-cascader :disabled="!iseditdev" style="width: 100%;" placeholder="请选择校区" v-model="exportorg" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="设备名" prop="name">
								<el-input :disabled="!iseditdev" clearable placeholder="设备名" v-model="adddevinfo.name">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="设备编码" prop="code">
								<el-input :disabled="!iseditdev" clearable placeholder="设备编码" v-model="adddevinfo.code">
								</el-input>
							</el-form-item >							
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="设备类型" prop="type">
								<el-select :disabled="!iseditdev" style="width: 100%;" v-model="adddevinfo.type" filterable clearable  placeholder="请选择类型">
									<el-option v-for="item in devtypeList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="设备型号" prop="model">
								<el-select :disabled="!iseditdev" style="width: 100%;" v-model="adddevinfo.model" filterable clearable  placeholder="请选择型号">
									<el-option v-for="item in devmodelList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="采集器编码" prop="controllid">
								<el-input :disabled="!iseditdev" clearable placeholder="采集器编码" v-model="adddevinfo.controllid">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20" >
						<el-col :span="8" v-if="isadd">
							<el-form-item label="上级设备编码" prop="parentid">
								<el-input :disabled="!iseditdev" clearable placeholder="上级设备编码" v-model="adddevinfo.parentid">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8" v-else-if="!iseditdev">
							<el-form-item label="上级设备编码" prop="parentid">
								<el-input :disabled="!iseditdev" clearable placeholder="上级设备编码" v-model="parentDev.code">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8" v-else>
							<el-form-item label="上级设备编码" prop="parentid">
								<el-input :disabled="!iseditdev" clearable placeholder="上级设备编码" v-model="adddevinfo.parentid">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="设备图标" prop="icon">
								<el-input :disabled="!iseditdev" clearable placeholder="设备图标" v-model="adddevinfo.icon">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="设备排序" prop="idx">
								<el-input-number :disabled="!iseditdev" v-model="adddevinfo.idx" style="width: 100%;" :min="1" :max="999" :precision="2" :step="0.1" >
								</el-input-number>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="isadd">
						<el-col :span="8">
							<el-form-item label="起始编号" prop="startnum">
								<el-input-number :disabled="!iseditdev" v-model="adddevinfo.startnum" placeholder="起始编号" style="width: 100%;" :min="1" :max="999" :precision="0" :step="1" >
								</el-input-number>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="结束编号" prop="endnum">
								<el-input-number :disabled="!iseditdev" v-model="adddevinfo.endnum" placeholder="结束编号" style="width: 100%;" :min="1" :max="999" :precision="0" :step="1" >
								</el-input-number>
							</el-form-item >
						</el-col>
						<el-col :span="8" v-show="'air-in' == adddevinfo.type">
							<el-form-item label="自动匹配" prop="autobind">
								<el-checkbox :disabled="!iseditdev" v-model="adddevinfo.autobind">内机自动匹配采集点位</el-checkbox>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="'air-in' != adddevinfo.type">
						<el-col :span="8">
							<el-form-item label="外机位置" prop="locname">
								<el-input :disabled="!iseditdev" clearable placeholder="设备位置" v-model="adddevinfo.locname">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<div style="margin-top: 20px;font-size: 12px;color:darkorange;">
						1、填写起始和结束编号，则会自动添加多个设备，设备名称无需添加编号。例如设备名“空调外机”，起始编号“1”，结束编号“10”，则会自动添加
						1#空调外机、2#空调外机、3#空调外机、4#空调外机、5#空调外机、6#空调外机、7#空调外机、8#空调外机、9#空调外机、10#空调外机 共
						10台空调外机设备。
						<br />
						2、上级设备编码是例如内机则需要填写上级设备(外机)的编码，需要先加上级设备。
						<br />
						3、内机自动匹配采集点位勾选上则会自动匹配内机属性
						<br />
						4、外机需要填写位置
					</div>
					<div style="margin-top: 20px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
						<div style="min-width: 120px;" v-show="isadd">
							<el-button type="primary" icon="el-icon-plus" @click="addDev">添加</el-button>
						</div>
						<div style="min-width: 300px;text-align: center;" v-show="!isadd" >
							<el-button v-show="!iseditdev" type="primary"  @click="iseditdev = true">修改</el-button>
							<el-button v-show="iseditdev"  @click="iseditdev = false">取消</el-button>
							<el-button v-show="iseditdev" type="primary" @click="saveEditDev">保存</el-button>
						</div>
					</div>
				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog @close="refrashData" :destroy-on-close="true" title="导入空调外机设备" width="80%" :visible.sync="showimportfromcj">
			<div>
				<el-form :inline="false" ref="devrule" label-width="120px" class="">
					<el-row>
						<el-col :span="12">
							<el-form-item label="所属校区" prop="org">
								<el-cascader style="width: 100%;" v-model="importairorgid" @change="orgSelect"
									:options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="4">
							<div style="min-width: 240px;">
								<el-button type="primary" @click="exportRoomAirInOut" icon="el-icon-download">导出</el-button>
							</div>
						</el-col>
					</el-row>
				</el-form>
				<div style="text-align: center;">
					<el-upload class="upload-demo" :limit="1" drag :action="importairuploadUrl" :data="extraData" 
						:before-upload="(file) => handleBeforeUpload(file) " accept=".xlsx" :headers="uploadheader" 
						:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList)">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">只能上传xlsx文件，且单个文件不超过1M</div>
					</el-upload>
				</div>
				<div style="color: #F56C6C;max-height: 300px;overflow: auto;margin-top: 10px;">
					<div v-html="errorinfo"></div>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog @close="refrashPointData" :destroy-on-close="true" :title="detailPointTitle" width="80%" :visible.sync="detailPointShow">
			<div>
				<el-form :inline="false" :model="adddevpointinfo" :rules="pointrules" ref="devpointrule" label-width="120px" class="">
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="属性名" prop="pointname">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="属性名" v-model="adddevpointinfo.point_name">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="point_code" prop="point_code">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="属性编码" v-model="adddevpointinfo.point_code">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="属性类型" prop="point_type">
								<el-select :disabled="!iseditdevpoint" style="width: 100%;" v-model="adddevpointinfo.point_type" filterable clearable  placeholder="请选择类型">
									<el-option v-for="item in pointtypeList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="单位" prop="unit">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="单位" v-model="adddevpointinfo.unit">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="8">
							<el-form-item label="排序" prop="idx">
								<el-input-number :disabled="!iseditdevpoint" v-model="adddevpointinfo.idx" placeholder="排序" style="width: 100%;" :min="1" :max="9999" :precision="2" :step="1" >
								</el-input-number>
							</el-form-item >							
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="取值公式" prop="value_expression">
								<el-input type="textarea" :rows="2" :disabled="!iseditdevpoint" clearable placeholder="取值公式" v-model="adddevpointinfo.value_expression">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="12">
							<el-form-item label="控制公式" prop="controll_expression">
								<el-input type="textarea" :rows="2" :disabled="!iseditdevpoint" clearable placeholder="控制公式" v-model="adddevpointinfo.controll_expression">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="取值引用点" prop="value_include">
								<el-input type="textarea" :rows="2" :disabled="!iseditdevpoint" clearable placeholder="取值公式" v-model="adddevpointinfo.value_include">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="12">
							<el-form-item label="控制引用点" prop="controll_include">
								<el-input type="textarea" :rows="2" :disabled="!iseditdevpoint" clearable placeholder="控制公式" v-model="adddevpointinfo.controll_include">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item label="枚举" prop="value_enum">
								<el-input type="textarea" :rows="2" :disabled="!iseditdevpoint" clearable placeholder="取值枚举" v-model="adddevpointinfo.value_enum">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="定时任务1" prop="task1">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="定时任务1" v-model="adddevpointinfo.task1">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="12">
							<el-form-item label="定时任务2" prop="task2">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="定时任务2" v-model="adddevpointinfo.task2">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="定时任务3" prop="task3">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="定时任务3" v-model="adddevpointinfo.task3">
								</el-input>
							</el-form-item >
						</el-col>
						<el-col :span="12">
							<el-form-item label="定时任务4" prop="task4">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="定时任务4" v-model="adddevpointinfo.task4">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="定时任务5" prop="task5">
								<el-input :disabled="!iseditdevpoint" clearable placeholder="定时任务5" v-model="adddevpointinfo.task5">
								</el-input>
							</el-form-item >
						</el-col>
					</el-row>
					<div style="margin-top: 20px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
						<div style="min-width: 120px;" v-show="isPointadd">
							<el-button type="primary" icon="el-icon-plus" @click="addDevPoint">添加</el-button>
						</div>
						<div style="min-width: 300px;text-align: center;" v-show="!isPointadd" >
							<el-button v-show="!iseditdevpoint" type="primary"  @click="iseditdevpoint = true">修改</el-button>
							<el-button v-show="iseditdevpoint"  @click="iseditdevpoint = false">取消</el-button>
							<el-button v-show="iseditdevpoint" type="primary" @click="saveEditDevPoint">保存</el-button>
						</div>
					</div>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryAllOrgTree, queryRealDevPage, queryRealDevPointsPage, addRealDev,
		editRealDev, deleteRealDev, addRealDevPoint, editRealDevPoint, deleteRealDevMulti,
		deleteRealDevPoint, queryRealDevById, queryRealDevTypeByPage,queryRealDevModelByPage } from '/static/apiUrl.js'
	import axios from 'axios'
	import { baseUrl, prefix } from '/public/baseUrl.js'
	export default {
		name : 'RealDev',
		data() {
			return {
				showimport : false,
				detailShow: false,
				detailPointShow: false,
				showimportfromcj : false,
				editok : false,
				isadd : false,
				iseditdev : false,
				iseditdevpoint : false,
				editPointok : false,
				isPointadd : false,
				showtaskimport : false,
				importtask : false,
				//importtaskuploadUrl : baseUrl + prefix + '/api/orgdev/importOrgAirTasks',
				importairuploadUrl : baseUrl + prefix + localStorage.getItem("citycode") + '/api/sys/importRoomRealDevAir',
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},
				errorinfo : '',
				detailTitle: '设备详情',
				detailPointTitle: '属性详情',
				exportorg : '',
				exporttype : '',
				importairorgid : [],
				searchInfo:{
					name: '',
					orgs : '',
				},
				searchPointInfo:{
					name: '',
					did : '',
				},
				allOrgTree : [],
				param : {
					page : 1,
					pagenum : 10,
				},
				pointparam : {
					page : 1,
					pagenum : 10,
				},
				selectids : [],
				devTotal : 0,
				devPointTotal : 0,
				orgDevList : [],
				orgDevPointList : [],
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				pointtypeList : [
					{ id : 'digital', name: '状态量'},
					{ id : 'analog', name: '模拟量'}
				],
				devtypeList : [
					{ id : 'air-out', name: '空调外机'},
					{ id : 'air-in', name: '空调内机'}
				],
				devmodelList : [
					{ id: 'power', name: '电表' },
					{ id: 'mdv4', name: '美的V4' },
					{ id: 'mdv6', name: '美的V6' },
					{ id: 'mdv8', name: '美的V8' },
				],
				adddevinfo: {
					id: '',
					orgid: '',
					name: '',
					code : '',
					icon: '',
					type: '',
					model: '',
					parentid : '',
					idx : 0,
					locname : '',
					startnum : 1,
					endnum : 1,
					controllid : '',
					autobind : false,
				},
				adddevpointinfo: {
					id: '',
					devid: '',
					point_name: '',
					point_code: '',
					point_type : '',
					unit: '',
					idx: 0,
					value_expression : '',
					controll_expression : '',
					value_include : '',
					controll_include : '',
					value_enum : '',
					task1 : '',
					task2 : '',
					task3 : '',
					task4 : '',
					task5 : '',
				},
				rules:{
					name: [
						{ required: true, message: '请输入设备名称', trigger: 'blur' }
					],
					type: [
						{ required: true, message: '请选择设备类型', trigger: 'blur' }
					],
					model: [
						{ required: true, message: '请选择设备型号', trigger: 'blur' }
					],
					idx: [
						{ required: true, message: '请输入设备排序', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入设备编码', trigger: 'blur' }
					],
				},
				pointrules : {
					point_name: [
						{ required: true, message: '请输入属性名称', trigger: 'blur' }
					],
					point_code: [
						{ required: true, message: '请输入属性编码', trigger: 'blur' }
					],
					point_type: [
						{ required: true, message: '请选择属性类型', trigger: 'blur' }
					],
				},
				parentDev : {
					id: '',
					name : '',
					code : ''
				},
				extraData: {
					orgid : '',
				},
			}
		},
		mounted() {
			this.initData()
			this.queryDevList()
		},
		components: {
			
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryDevList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryDevList()
			},
			handlePointSizeChange(val){
				this.pointparam.pagenum = val;
				this.queryDevPointList()
			},
			handlePointCurrentChange(val){
				this.pointparam.page = val
				this.queryDevPointList()
			},
			initData() {
				this.allOrgTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
				this.devtypeList = []
				queryRealDevTypeByPage({
					name:'',
					pagenum : 1 ,
					pagesize : 100
				}).then(res => {
					if( 0 == res.code){
						res.datas.data.forEach((set) => {
							this.devtypeList.push({
								id : set.code,
								name : set.name
							})
						})
					}
				})
				this.devmodelList = []
				queryRealDevModelByPage({
					name:'',
					pagenum : 1 ,
					pagesize : 100
				}).then(res => {
					if( 0 == res.code){
						res.datas.data.forEach((set) => {
							this.devmodelList.push({
								id : set.code,
								name : set.name
							})
						})
					}
				})
			},
			searchDev(){
				this.param.page = 1
				this.orgDevList = []
				this.queryDevList()
			},
			searchDevPoint(){
				this.pointparam.page = 1
				this.orgDevPointList = []
				this.queryDevPointList()
			},
			clearDevSearch(){
				this.searchInfo.name = ''
				this.searchInfo.orgs = ''
				this.param.page = 1
				this.queryDevList()
			},
			clearDevPointSearch(){
				//this.searchPointInfo.name = ''
				this.pointparam.page = 1
				this.queryDevPointList()
			},
			rowSelected(row, column, event){
				this.searchPointInfo.did = row.id
				this.clearDevPointSearch()
			},
			queryDevPointList(){
				this.orgDevPointList = []
				queryRealDevPointsPage({
					devid : this.searchPointInfo.did,
					name : this.searchPointInfo.name,
					pagenum : this.pointparam.page ,
					pagesize : this.pointparam.pagenum
				}).then(res => {
					if(0 == res.code){
						this.devPointTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.orgDevPointList.push(set)
						})
					}else{
						this.devPointTotal = 0
					}
				})
			},
			queryDevList(){
				this.orgDevList = []
				this.orgDevPointList = []
				let orgid = ""
				if(this.searchInfo.orgs.length > 0){
					orgid = this.searchInfo.orgs[this.searchInfo.orgs.length -1]
				}
				queryRealDevPage({
					oid : orgid,
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.devTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.orgDevList.push(set)
						})
					}else{
						this.devTotal = 0
					}
				})
			},
			goDevDetail(idx,row){
				this.detailTitle = '设备详情'
				this.isadd = false
				this.iseditdev = false
				this.editok = false
				let selecteddev = JSON.parse(JSON.stringify(this.orgDevList[idx]))
				this.adddevinfo.id = selecteddev.id
				this.adddevinfo.orgid = selecteddev.orgid
				this.adddevinfo.name= selecteddev.name
				this.adddevinfo.code = selecteddev.code
				this.adddevinfo.icon= selecteddev.icon
				this.adddevinfo.type= selecteddev.type
				this.adddevinfo.model= selecteddev.model
				this.adddevinfo.locname = selecteddev.locname
				//this.adddevinfo.parentid = selecteddev.parentid
				this.adddevinfo.idx = selecteddev.idx
				this.adddevinfo.controllid = ''
				this.adddevinfo.autobind = false
				this.exportorg = selecteddev.orgid
				if(selecteddev.parentid){
					queryRealDevById({id: selecteddev.parentid}).then(res => {
						if(0 == res.code){
							this.parentDev.id = res.datas.id
							this.parentDev.name = res.datas.name
							this.parentDev.code = res.datas.code
							this.adddevinfo.parentid = res.datas.code
						}
					})
				}
				this.detailShow = true
			},
			goDevPointDetail(idx,row){
				this.detailPointTitle = '属性详情'
				this.isPointadd = false
				this.iseditdevpoint = false
				let selectpointset = JSON.parse(JSON.stringify(this.orgDevPointList[idx]))
				this.adddevpointinfo.id = selectpointset.id,
				this.adddevpointinfo.devid = selectpointset.devid
				this.adddevpointinfo.point_name = selectpointset.point_name
				this.adddevpointinfo.point_code = selectpointset.point_code
				this.adddevpointinfo.point_type = selectpointset.point_type
				this.adddevpointinfo.unit = selectpointset.unit
				this.adddevpointinfo.idx = selectpointset.idx
				this.adddevpointinfo.value_expression  = selectpointset.value_expression
				this.adddevpointinfo.controll_expression  = selectpointset.controll_expression
				this.adddevpointinfo.value_include  = selectpointset.value_include
				this.adddevpointinfo.controll_include  = selectpointset.controll_include
				this.adddevpointinfo.value_enum  = selectpointset.value_enum
				this.adddevpointinfo.task1  = selectpointset.task5
				this.adddevpointinfo.task2  = selectpointset.task2
				this.adddevpointinfo.task3  = selectpointset.task3
				this.adddevpointinfo.task4  = selectpointset.task4
				this.adddevpointinfo.task5  = selectpointset.task5
				this.detailPointShow = true
			},
			deleteDetail(idx,row){
				this.$confirm('此操作将删除设备 '+this.orgDevList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteRealDev({id: this.orgDevList[idx].id}).then(res => {
						if(0 == res.code){
							this.queryDevList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			handleSelectionChange(val){
				this.selectids = [];
				if(val.length > 0){
					val.forEach((item) => {
						this.selectids.push(item.id)
					})
				}
			},
			deleteSelectedRealDev(){
				if(this.selectids.length == 0){
					this.$message({
						showClose: true,
						message: '请选择需要删除的设备。',
						type: 'warning'
					});
					return
				}
				this.$confirm('确定删除选中的设备吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: '删除数据中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					deleteRealDevMulti(this.selectids).then(res => {
						if(0 == res.code){
							this.queryDevList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
						loading.close();
					})
				}).catch(() => {
					console.log("取消")
				})
			},
			deletePointDetail(idx,row){
				this.$confirm('此操作将删除点位 '+this.orgDevPointList[idx].point_name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteRealDevPoint({
						id: this.orgDevPointList[idx].id
					}).the(res => {
						if(0 == res.code){
							this.queryDevPointList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addStall(){
				this.detailTitle = "添加设备"
				this.isadd = true
				this.editok = false
				this.adddevinfo.id = ''
				this.adddevinfo.orgid = ''
				this.adddevinfo.name= ''
				this.adddevinfo.code = ''
				this.adddevinfo.icon= ''
				this.adddevinfo.type= ''
				this.adddevinfo.model= ''
				this.adddevinfo.parentid = ''
				this.adddevinfo.idx = 1
				this.adddevinfo.startnum = 1
				this.adddevinfo.endnum = 1
				this.adddevinfo.controllid = ''
				this.adddevinfo.autobind = false
				this.adddevinfo.locname = ''
				this.exportorg = ''
				this.detailShow = true
				this.iseditdev = true
			},
			addPointStall(){
				if(this.searchPointInfo.did == null || this.searchPointInfo.did == ''){
					this.$message({
						showClose: true,
						message: "请先选择设备",
						type: 'warning'
					});
				}else{
					this.detailPointTitle = "添加属性"
					this.isPointadd = true
					this.adddevpointinfo = {
						id: '',
						devid: this.searchPointInfo.did,
						point_name: '',
						point_code : '',
						unit: '',
						idx: 0,
						value_expression : '',
						controll_expression : '',
						value_include : '',
						controll_include : '',
						value_enum : '',
						point_type : '',
						task1 : '',
						task2 : '',
						task3 : '',
						task4 : '',
						task5 : '',
					}
					this.iseditdevpoint = true
					this.detailPointShow = true
				}
			},
			refrashData() {
				if(this.editok){
					this.queryDevList()
				}
			},
			refrashPointData() {
				if(this.editPointok){
					this.queryDevPointList()
				}
			},
			addDev(){
				this.$refs["devrule"].validate((valid) => {
					if (valid) {
						const isArr = Array.isArray(this.exportorg);
						if(isArr && this.exportorg.length > 0){
							this.adddevinfo.orgid = this.exportorg[this.exportorg.length-1]
						}else{
							this.adddevinfo.orgid = this.exportorg
						}
						if(this.adddevinfo.orgid == null || this.adddevinfo.orgid == ''){
							this.$message({
								showClose: true,
								message: "请选择校区",
								type: 'warning'
							});
							return;
						}
						//TODO
						addRealDev(this.adddevinfo).then(res => {
							if(0 == res.code){
								this.queryDevList()
								this.detailShow = false
								this.editok = true
								this.$message({
									showClose: true,
									message: "添加成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
						})
					} else {
						return false;
					}
				});
			},
			saveEditDev(){
				this.$refs["devrule"].validate((valid) => {
					if (valid) {
						const isArr = Array.isArray(this.exportorg);
						if(isArr && this.exportorg.length > 0){
							this.adddevinfo.orgid = this.exportorg[this.exportorg.length-1]
						}else{
							this.adddevinfo.orgid = this.exportorg
						}
						if(this.adddevinfo.orgid == null || this.adddevinfo.orgid == ''){
							this.$message({
								showClose: true,
								message: "请选择校区",
								type: 'warning'
							});
							return;
						}
						//TODO
						editRealDev(this.adddevinfo).then(res => {
							if(0 == res.code){
								this.queryDevList()
								this.detailShow = false
								this.editok = true
								this.$message({
									showClose: true,
									message: "修改成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
						})
					} else {
						return false;
					}
				});
			},
			addDevPoint(){
				if(this.adddevpointinfo.devid == null || this.adddevpointinfo.devid == ''){
					this.$message({
						showClose: true,
						message: "请选择需要添加属性的设备",
						type: 'warning'
					});
					return;
				}
				this.$refs["devpointrule"].validate((valid) => {
					if (valid) {
						addRealDevPoint(this.adddevpointinfo).then(res => {
							if(0 == res.code){
								//this.queryDevPointList()
								this.detailPointShow = false
								this.editPointok = true
								this.$message({
									showClose: true,
									message: "添加成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
						})
					} else {
						return false;
					}
				});
			},
			saveEditDevPoint(){
				if(this.adddevpointinfo.devid == null || this.adddevpointinfo.devid == ''){
					this.$message({
						showClose: true,
						message: "请选择需要添加属性的设备",
						type: 'warning'
					});
					return;
				}
				this.$refs["devpointrule"].validate((valid) => {
					if (valid) {
						editRealDevPoint(this.adddevpointinfo).then(res => {
							if(0 == res.code){
								//this.queryDevPointList()
								this.detailPointShow = false
								this.editPointok = true
								this.$message({
									showClose: true,
									message: "修改成功",
									type: 'success'
								});
							}else{
								this.$message({
									showClose: true,
									message: res.message,
									type: 'error'
								});
							}
						})
					} else {
						return false;
					}
				});
			},
			orgSelect(val){
				if(val.length > 0){
					this.extraData.orgid = val[val.length - 1]
				}
			},
			handleBeforeUpload(file){
				this.errorinfo = ''
				if(this.importairorgid.length == 0){
					this.$message.warning("请先选择所属校区");
					return false
				}
				const isLtSize = file.size / 1024 / 1024 < 10;
				if (!isLtSize) {
					this.$message.warning("导入文件大小不能超过 10MB!");
					return false;
				}
				return file
			},
			handleUploadSucc(response,file,fileList){
				if(0 == response.code){
					this.$message({
						showClose: true,
						message: "导入完成",
						type: 'success'
					});
					if(response.message){
						this.errorinfo += response.message.replace(";","<br>").replaceAll("；","<br/>")
					}
				}else{
					this.$message.error(response.message)
				}
			},
			exportRoomAirInOut(){
				if(this.extraData.orgid == null || this.extraData.orgid == ''){
					this.$message({
						showClose: true,
						message: "请选择要导出的校区",
						type: 'warning'
					});
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '导出数据中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let orgid = this.extraData.orgid
				let filename = orgid + '教室内外机关系.xlsx'
				let autherheader = sessionStorage.getItem("authToken")
				let citycode = localStorage.getItem("citycode")
				let cityurl = baseUrl+prefix+citycode
				axios.get(cityurl+'/api/orgdev/roomAirRelExport?oid='+orgid, 
				{
					headers: {
						'Content-Type': 'blob',
						Authorization: autherheader
					},
					timeout : 500000,
					responseType : 'blob'
				}).then(response => {
					loading.close();
					const url = window.URL.createObjectURL(new Blob([response.data]),{type:`'application/vnd.ms-excel';chartset=utf-8`});
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link)
				}).catch(err => {
					console.log(err)
					loading.close();
					this.$message({
						showClose: true,
						message: "超时",
						type: 'error'
					});
				});
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>